"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDefaultTitle = exports.notNullOrUndefined = exports.notNullOrEmpty = exports.classes = exports.path = void 0;
const SEPARATOR_SLASH = '/';
const SEPARATOR_SPACE = ' ';
const path = (...segments) => segments.filter(s => s && s.length).join(SEPARATOR_SLASH);
exports.path = path;
const classes = (...classses) => classses.filter(s => s && s.length).join(SEPARATOR_SPACE);
exports.classes = classes;
const notNullOrEmpty = (value) => value && value.length > 0;
exports.notNullOrEmpty = notNullOrEmpty;
const notNullOrUndefined = (value) => value !== null && value !== undefined;
exports.notNullOrUndefined = notNullOrUndefined;
const removeDefaultTitle = () => {
    const titleEl = document.head.getElementsByTagName('title');
    if (titleEl && titleEl[0] && titleEl[0].parentNode) {
        titleEl[0].parentNode.removeChild(titleEl[0]);
    }
};
exports.removeDefaultTitle = removeDefaultTitle;
